const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on("unmount", () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

// UI COMPONENTS ==============================================================
// import MiniCart from './components/ui/cart/MiniCart';
// import QuickSearch from './components/ui/QuickSearch';
// import SubscribeModal from './components/ui/SubscribeModal';

// NAV COMPONENTS ==============================================================
// import MobileNav from './components/nav/MobileNav';

export const AppComponents = {
  // Content Components ------------------------------------------------------------
  // RecommendedProducts: asyncComponentFactory('content/RecommendedProducts'),
  // MEDIA Components ------------------------------------------------------------
  // MediaPlayer: asyncComponentFactory('media/MediaPlayer'),
  // UI Components ------------------------------------------------------------
  // Accordion: asyncComponentFactory('ui/Accordion'),
  // AutoComplete: asyncComponentFactory('ui/AutoComplete'),
  // Dropdown: asyncComponentFactory('ui/Dropdown/index.js'),
  // ProductMain: asyncComponentFactory('ui/ProductMain/index.js'),
  // Collage: asyncComponentFactory('ui/Collage'),
  // CollectionMain: asyncComponentFactory('ui/CollectionMain'),
  // SimpleCollectionList: asyncComponentFactory('ui/SimpleCollectionList'),
  // CollectionApplications: asyncComponentFactory('ui/CollectionApplications'),
  // LazyLoader: asyncComponentFactory('ui/LazyLoader'),
  // MainCart: asyncComponentFactory('ui/cart/MainCart'),
  // MiniCart,
  // QuickSearch,
  // SocialGallery: asyncComponentFactory('ui/SocialGallery'),
  // SearchMain: asyncComponentFactory('ui/SearchMain'),
  // Tabs: asyncComponentFactory('ui/Tabs'),
  // Modal: asyncComponentFactory('ui/Modal'),
  // Slider: asyncComponentFactory('ui/Slider'),
  // SubscribeModal,
  // NAV Components ------------------------------------------------------------
  // MobileNav,
};
